import { render, staticRenderFns } from "./ClmPaytType.vue?vue&type=template&id=1b6fcf92&"
import script from "./ClmPaytType.vue?vue&type=script&lang=js&"
export * from "./ClmPaytType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports